import { Autocomplete, TextField } from "@mui/material";
import useStateData from "../../Queries/stateDataQuery";
import { useBoundStore } from "useStore";

const DEFAULT_ESTADO_ID = 2;

export default function StatusFilter({ countryId }) {
  const stateDataQuery = useStateData({ countryId });
  const statusData = stateDataQuery.data ?? [];
  const selectedStatus = useBoundStore((state) => state.soTallerSelectedStatus);
  const defaultStatus =
    statusData.find((s) => s.id === DEFAULT_ESTADO_ID) ?? statusData[0] ?? null;
  const displayValue = selectedStatus ?? defaultStatus;
  return (
    <Autocomplete
      disabled
      id="taller-status-filter"
      options={statusData}
      getOptionLabel={(option) => option.nombre_estado ?? ""}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={displayValue}
      onChange={() => {}}
      sx={{
        width: 300,
        "& .MuiOutlinedInput-root": {
          backgroundColor: "#fff",
          borderRadius: "8px",
        },
        "& .MuiInputBase-input": {
          backgroundColor: "#fff !important",
          borderRadius: "8px",
          WebkitBoxShadow: "0 0 0 1000px white inset",
          "-webkit-text-fill-color": "rgba(0,0,0,0.87) !important",
        },
        "& .Mui-disabled": {
          opacity: 1,
        },
      }}
      renderInput={(params) => (
        <TextField {...params} label="Estado" disabled />
      )}
    />
  );
}
